import { utcToTime } from "../../../Utils/formant";

const ColorPieList = (key) => {
  switch (key) {
    case "Completed":
      return "#33ff99";

    case "Half Delivered":
      return "#ffff99";

    case "No Receiver":
      return "#ff8080";

    case "Rejected":
      return "#ff4d4d";

    case "Remain":
      return "#00cccc";

    default:
      return "#00cccc";
  };
};

// const getTime = (time, interval) => {
//   const Time = new Date(time);
//   switch (interval) {
//     case "HOUR":
//       return (Time.getHours() + ":" + Time.getMinutes());
//     case "DAY":
//       return (Time.getHours() + ":" + Time.getMinutes());
//     case "MONTH":
//       return ((Time.getMonth() + 1) + "/" + Time.getDay() + " " + Time.getHours() + ":" + Time.getMinutes());
//     case "YEAR":
//       return ((Time.getMonth() + 1) + "/" + Time.getFullYear());
//     default:
//       return ((Time.getMonth() + 1) + "/" + Time.getFullYear());
//   };
// }

const changeDistanceSchema = (data, interval) => {
  const newData = data.map((item) => {
    const Time = new Date(item.date_range)
    return {
      name: interval === "HOUR" ? utcToTime(Time, "HH:mm") : (interval === "DAY") ? utcToTime(Time, "jYYYY/jM/jD") : interval === "MONTH" ? utcToTime(Time, "jYYYY/jM") : utcToTime(Time, "jYYYY"),
      "Average of Distance": parseFloat(item.averageofdistance) || 0,
      Distance: parseFloat(item.distance) || 0,
      "Mission Count": item.missioncount,
    };
  });
  return newData;
};
const changeDurationSchema = (data, interval) => {
  const newData = data.map((item) => {
    const Time = new Date(item.date_range)
    return {
      name: interval === "HOUR" ? utcToTime(Time, "HH:mm") : (interval === "DAY") ? utcToTime(Time, "jYYYY/jM/jD") : interval === "MONTH" ? utcToTime(Time, "jYYYY/jM") : utcToTime(Time, "jYYYY"),
      "Average of Duration": parseFloat(item.averageofduration) || 0,
      Duration: parseFloat(item.duration) || 0,
      "Mission Count": item.missioncount,
    };
  });
  return newData;
};
const MissionStatus = (data, interval) => {
  const newData = data.map((item) => {
    const Time = new Date(item.date_range)
    return {
      name: interval === "HOUR" ? utcToTime(Time, "HH:mm") : (interval === "DAY") ? utcToTime(Time, "jYYYY/jM/jD") : interval === "MONTH" ? utcToTime(Time, "jYYYY/jM") : utcToTime(Time, "jYYYY"),
      Completed: item.completed,
      "Half Delivered": item.half_delivered,
      Rejected: item.rejected,
      "No Receiver": item.no_receiver,
      Total: item.total,
      Remaining: item.remain,
    };
  });

  const totalCounter = data.reduce((acc, item) => {
    return {
      Completed: item.completed + acc.Completed,
      "Half Delivered": item.half_delivered + acc["Half Delivered"],
      Rejected: item.rejected + acc.Rejected,
      "No Receiver": item.no_receiver + acc["No Receiver"],
      Remaining: item.remain + acc.Remaining,
    }
  }, {
    Completed: 0,
    "Half Delivered": 0,
    Rejected: 0,
    "No Receiver": 0,
    Remaining: 0,
  });

  const PieData = Object.keys(totalCounter).map(key => {
    return {
      name: key,
      value: totalCounter[key],
      color: ColorPieList(key)
    }
  })

  return [newData, PieData];
};

const ChartsHasDataOrNot = (duration, distance, Status, TotalStatus) => {
  const AvgDuration = Object.values(duration).every(item => item["Average of Duration"] === 0);
  const AvgDistance = Object.values(distance).every(item => item["Average of Distance"] === 0);
  const missionStatusPie = Object.values(TotalStatus).every(item => item.value === 0);
  const missionStatusStack = Object.values(Status).every(item => item.Total === 0);

  return {
    AvgDuration: AvgDuration,
    AvgDistance: AvgDistance,
    missionStatusPie: missionStatusPie,
    missionStatusStack: missionStatusStack,
  };
};

const changeNullValueToZero = (res) => {
  Object.keys(res).forEach(item => {
    if (res[item] === null) {
      res[item] = 0;
    }
  })

  return res;
}

export const getAllData = (state) => {
  const updateValue = {
    request: true,
    response: null,
    error: null,
  };
  return { ...state, getAllData: { ...updateValue } };
};
export const getAllDataSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: true,
    error: null,
  };
  const excel = {
    AvgDuration: action.res.durationOfDelivery.excel,
    AvgDistance: action.res.distanceOfDelivery.excel,
    Delivery: action.res.MissionStatus.excel,
  }

  const distanceOfDelivery = changeDistanceSchema(action.res.distanceOfDelivery.data, state.interval);

  const durationOfDelivery = changeDurationSchema(action.res.durationOfDelivery.data, state.interval);

  const missionStatusResult = MissionStatus(action.res.MissionStatus.data, state.interval);
  const Status = missionStatusResult[0];
  const TotalStatus = missionStatusResult[1];

  const noChartData = ChartsHasDataOrNot(durationOfDelivery, distanceOfDelivery, Status, TotalStatus);

  const analyticsResult = changeNullValueToZero(action.res.analytics)

  return {
    ...state,
    noChartData,
    distanceOfDelivery,
    durationOfDelivery,
    missionStatus: Status,
    totalMissionStatus: TotalStatus,
    analytics: analyticsResult,
    getAllData: { ...updateValue },
    excel,
  };
};
export const getAllDataFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error.response,
  };

  return { ...state, getAllData: { ...updateValue } };
};

export const ClearState = (state, action, initialState) => {
  return { ...state, [action.stateName]: initialState[action.stateName] };
};

export const setInterval = (state, action) => {
  return { ...state, interval: action.interval };
};
